import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutlayout_diwfalias extends Layout {
    sourceDidbalias: DataSource;
    sourceDiwfalias: DataSource;
    sourceImgApps: DataSource;
    tbImapAppid: Textbox;
    tbImapAppname: Textbox;
    textboxDidbDbalias: Textbox;
    textboxDidbDesc: Textbox;
    textboxDiwfaAppid: Textbox;
    textboxDiwfaDbalias: Textbox;
    textboxDiwfaDesc: Textbox;
    textboxDiwfaWfalias: Textbox;
    textboxImapAppname: Textbox;
}
